<section class="mask-curve-top bg-anis py-7">
  <div class="centered-with-padding flex items-center justify-center gap-x-4 py-12 desk:gap-x-7 desk:py-10">
    <app-title [title]="data.title" size="h1" />
    <app-svg [height]="102" [src]="data.picto.svg" [width]="86" class="-rotate-6" />
  </div>
</section>
